// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1R447","insightsList":"newBusinessInsightsMenu_insightsList__3aO34","active":"newBusinessInsightsMenu_active__3-Bje"};